import { Cookie } from "@ts/core/Cookie";
import { instruction } from "@ts/core/Instruction";
import { simpleForm } from "@ts/core/SimpleForm";
import { uploadFile } from "@ts/core/uploadFile";
import { yesNo } from "@ts/core/YesNo";
import { ImagesData } from "@ts/data/ImagesData";

export function createImageSection() : Promise<ImagesData | false> {
    
    return new Promise((success, abort) => {
        instruction('Välj den bild du vill ladda upp').then((result) => {
            if (!result) return abort(false);

            const data = new Object as ImagesData;
            data.imageid = 0;
            data.imagefile = '';
            data.comment = '';
            data.rotation = 0;
            data.size = 0;
            data.shadow = true;

            uploadFile('image', Cookie.pagename)
                .then((resolve: string | false) => {
                    if (!resolve) return abort(false);

                    data.imagefile = resolve;
                    simpleForm('Bild', 4, 'Lägg till kommentar', '',
                        'Skiv din kommentar här eller lämna tomt om du inte vill lägga till en')
                        .then((text: string) => {
                            data.comment = text;
                        });

                    yesNo('Skugga', 'Vill du att bilden ska ha skuggning?')
                        .then((result: boolean) => {
                            data.shadow = result;
                        });

                    success(data);

                });
            abort(false);

        });

    });
}